export default "__VITE_ASSET__cd888b54__"